module.exports = __webpack_public_path__ + "static/image/serveEWM.ed91983.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serveEWM.jpeg
// module id = 379
// module chunks = 1